import { HttpClient, HttpHeaders } from '@angular/common/http'
import * as XLSX from 'xlsx'
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { NavigationEnd, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { fromEvent } from 'rxjs'
import { debounceTime, filter, switchMap } from 'rxjs/operators'
import { AddTypeLocationsComponent } from 'src/app/modal/add-type-locations/add-type-locations.component'
import {
  Lector,
  ResponseCompanyCharges,
  ResponseCompanyChargesAccounting,
  ResponseCustomerCharges,
  ResponseCustomerChargesAccounting,
  ResponseInvoiceHeader,
  ResponseInvoiceItemsList,
  ResponseLocalitation,
  ResponseLocalitationNew,
  ResponseUSer,
  ResponseUsersAdmin,
  ResponseWarehouseNameLocation,
  RRequesttypeLocations,
  Wms
} from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component'
import { AddSendEmailComponent } from '../modal/add-send-email/add-send-email.component'
import { WarehouseNameLocationComponent } from '../modal/warehouse-name-location/warehouse-name-location.component'
@Component({
  selector: 'app-administrador',
  templateUrl: './administrador.component.html',
  styleUrls: ['./administrador.component.css']
})
export class AdministradorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  ResponseInvoiceItemsList:ResponseInvoiceItemsList[];
dataWms:Wms;
ResponseInvoiceHeader:ResponseInvoiceHeader[];
  ResponseLocalitationExcel: ResponseLocalitationNew[]
  ResponseWarehouseNameLocation: ResponseWarehouseNameLocation
  ResponseWarehouseNameLocationArray: ResponseWarehouseNameLocation[]
  FormWarehouseName: FormGroup
  FormRouting: FormGroup
  EditRouting = 0
  viewRouting = true
  arrayDescripionRouting = []
  selectedCOmpanyCharges = '1'
  selectedCustomerCharges = '1'
  IdCustomerChargesEdit = 0
  tab1 = true
  tabfalse = false
  indexTabs24 = new FormControl(0)
  idCompanyCharges = 0
  FromCustomerCharges: FormGroup
  FomCompanyCharges: FormGroup
  invoiceList = []
  respuestaLocation: string
  arraytypeLocation: RRequesttypeLocations[]
  arraytypeLocationselest: RRequesttypeLocations[]
  datosDialogTypeLocations: RRequesttypeLocations
  mySubscription: any
  currentUser: ResponseUSer
  PerfilCustomer = false
  permiso1 = true
  permiso2 = true
  permiso3 = true
  permiso1value = false
  permiso2value = false
  permiso3value = false
  viewUsers = true
  editarID = 0
  EditarTxto = 'Save'

  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  checked = false
  indeterminate = false
  labelPosition: 'before' | 'after' = 'after'
  disabled = false
  ButtonLocalizzacionText = 'Save'
  editarlocalzacionId: Number
  editarLocalizacion = false
  FormularioLocalizzacion: FormGroup
  formularioUsuarios: FormGroup
  displayedColumns: string[] = [
    'id',
    'location',
    'locationLength',
    'locationWidth',
    'locationHeight',
    'locationTemperature',
    'lowQuantity',
    'locationDescription',
    'locationType',
    'active'
  ]
  dataSource: MatTableDataSource<ResponseLocalitationNew>
  PlaceOrderCustomer = []
  @ViewChild('paginadorlo') paginator: MatPaginator
  @ViewChild('TableLocaSort') sort: MatSort

  displayedColumnsSearch: string[] = [
    'id',
    // 'ClientAccNum',
    'Name',
    'Last_Name',
    'User_Address',
    'City',
    // 'User_State',
    'Zip',
    'Phone',
    'Ext',
    // 'Cell_Phone',
    // 'Fax',
    'Email',
    'UserPassword',
    'Active',
    // 'AcceptedTOS',
    // 'AcceptedTOSDate',
    // 'PictureLocation',
    // 'IMSApp',
    // 'tblAppThemeID',
    'Date_Created'
    //,
    // 'tblAppThemeBGColor',
    // 'tblAppThemeFontColor',
    // 'tblAppThemeFontSize',
    // 'tblAppThemeFontFamily'
  ]
  dataSourceSearch: MatTableDataSource<ResponseUsersAdmin>
  datosLector: Lector
  @ViewChild('paginatorSearch') paginatorSearch: MatPaginator
  @ViewChild('sortSearch') sortSearch: MatSort
  editChargesCompany = 0
  datosSelectChange: any
  arrayTableCompanyCharges: ResponseCompanyChargesAccounting[]
  CompanyChargesdisplayedColumns: string[] = [
    'Id',
    'CompanyID',
    'Accessorial',
    'ChargeAmount',
    'Date_Created',
    'Active',
    'tblInvoiceListID',
    'QBIntegrated',
    'QBIntegratedDate',
    'QBIntegratedStatus',
    'QBListID',
    'QBChartOfAccount',
    'tblChartOfAccount'

  ]
  CompanyChargesdataSource: MatTableDataSource<ResponseCompanyChargesAccounting>

  @ViewChild('CompanyChargesPaginator') CompanyChargespaginator: MatPaginator
  @ViewChild('CompanyChargesSort') CompanyChargessort: MatSort
  CustomerChargesdisplayedColumns: string[] = [
    'id',
    'tblCustomerID',
    'Company_Name',
    'tblCompanyChargesID',
    'Amount',
    'Active'
  ]
  arrayDataCustomerCharges: ResponseCustomerChargesAccounting[]
  CustomerChargesSource: MatTableDataSource<ResponseCustomerChargesAccounting>
  @ViewChild('CustomerChargesPaginator') CustomerChargespaginator: MatPaginator
  @ViewChild('CustomerChargesSort') CustomerChargessort: MatSort
  selectedDescription = '1'
  constructor (
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formbuider: FormBuilder,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {
    this.PlaceOrderCustomer = []
    this.invoiceList = []
    this.arrayDescripionRouting = []
    this.ResponseWarehouseNameLocationArray = []
    this.ResponseInvoiceHeader=[];
    this.ResponseInvoiceItemsList=[];
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(events => {
        this.authenticationService.currentUser.subscribe(
          x => (this.currentUser = x)
        )
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd')
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true
      }
    })
    this.arrayTableCompanyCharges = []
    this.dataSource = new MatTableDataSource(null)
    this.CompanyChargesdataSource = new MatTableDataSource(
      this.arrayTableCompanyCharges
    )
    this.ResponseLocalitationExcel = []
    this.arrayDataCustomerCharges = []
    this.CustomerChargesSource = new MatTableDataSource(
      this.arrayDataCustomerCharges
    )
  }
  ngOnDestroy (): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
    var element = document.getElementById('SubMenu')
    element.style.display = 'none'

    localStorage.setItem('header', '0')
  }
  ngAfterViewInit (): void {
    this.onTableWarehouseNameLocation()
    this.FormularioLocalizzacion.controls.checked.setValue('1')
    try {
      this.CompanyChargesdataSource.sort = this.CompanyChargessort
      this.CompanyChargesdataSource.paginator = this.CompanyChargespaginator
      this.CustomerChargesSource.sort = this.CustomerChargessort
      this.CustomerChargesSource.paginator = this.CustomerChargespaginator
    } catch (error) {}
  }

  ngOnInit (): void {
    this.FormRouting = this.formbuider.group({
      Description: [''],
      Active: ['']
    })
    this.FormularioLocalizzacion = this.formbuider.group({
      Location: ['', Validators.required],
      Length: [''],
      Width: [''],
      Heigth: [''],
      Temperature: [''],
      quantity: ['', Validators.required],
      Description: [''],
      Type: ['', Validators.required],
      checked: ['']
    })
    this.formularioUsuarios = this.formbuider.group({
      permiso: [''],
      customer: [''],
      activo: [''],
      name: [''],
      lastname: [''],
      Address: [''],
      City: [''],
      State: [''],
      Zip: [''],
      Phone: [''],
      Fax: [''],
      Email: [''],
      Password: ['']
    })
    this.FomCompanyCharges = this.formbuider.group({
      invoiceList: [''],
      Accessorial: [''],
      Amount: [''],
      Active: [true],
      Integrated: [''],
      IntegratedStatus: ['']
    })
    this.FromCustomerCharges = this.formbuider.group({
      custome: [''],
      Amount: [''],
      Active: ['']
    })
    this.FormWarehouseName = this.formbuider.group({
      ID: [0],
      CompanyID: [0],
      Warehouse_Name: [''],
      Contact_Name: [''],
      Address: [''],
      Address1: [''],
      City: [''],
      State: [''],
      Zip: [''],
      Phone: [''],
      Fax: [''],
      Email: [''],
      Logo: [''],
      Admin_License: [1],
      Partner_License: [1],
      Client_License: [1],
      Active: [true],
      Company_Website: [''],
      PaymentBTN: [0],
      Date_Created: [new Date(new Date())],
      orderBy: [1]
    })
    this.OnChangeInvoiceList()
    this.OnChangeLoader()
    this.OnViewSearch()
    this.OnLocation('')
    this.OnSelectCostumer()
    this.OnTypeLocationSelect()
    this.OnChargesCompanyView()
    this.OnCustomerCharges()
    this.formularioUsuarios.controls.activo.setValue('1')
    this.FormularioLocalizzacion.controls.quantity.setValue('1.00')
    this.FormularioLocalizzacion.controls.Length.setValue('1.00')
    this.FormularioLocalizzacion.controls.Width.setValue('1.00')
    this.FormularioLocalizzacion.controls.Heigth.setValue('1.00')
    this.FormularioLocalizzacion.controls.Temperature.setValue('1.00')
    this.FormularioLocalizzacion.controls.Type.setValue('1')
    try {
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    } catch (error) {}
    this.OnSelectRouting()
  }
  OnLocation (search: any) {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )

    var ss = String(search)
    if (ss == '') {
      this._httpClient
        .get<any>(
          `${
            environment.apiUrl
          }/Administracion/SearchLocationsNew?companyId=${Number(
            this.authenticationService.currentUserValue.companyIdWh
          )}&active=1&search=${String(search)}`,

          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: ResponseLocalitationNew[]) => {
          this.dataSource.data = []
          this.ResponseLocalitationExcel = response
          this.dataSource = new MatTableDataSource(response)

          this.dataSource.sort = this.sort
          this.dataSource.paginator = this.paginator
        })
    } else {
      if (ss.length > 3) {
        this._httpClient
          .get<any>(
            `${
              environment.apiUrl
            }/Administracion/SearchLocationsNew?companyId=${Number(
              this.authenticationService.currentUserValue.companyIdWh
            )}&active=1&search=${String(search)}`,

            {
              headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                Authorization:
                  'Bearer ' + this.authenticationService.currentUserValue.token
              })
            }
          )
          .subscribe((response: ResponseLocalitationNew[]) => {
            this.dataSource.data = []
            this.ResponseLocalitationExcel = response
            this.dataSource = new MatTableDataSource(response)

            this.dataSource.sort = this.sort
            this.dataSource.paginator = this.paginator
          })
      } else {
      }
    }
  }
  OnViewSearch () {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/SerchUserAccounts`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseUsersAdmin[]) => {
        this.dataSourceSearch = new MatTableDataSource(response)
        this.dataSourceSearch.paginator = this.paginatorSearch
        this.dataSourceSearch.sort = this.sortSearch
      })
  }
  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage()
    }
  }
  applyFilterCompanyCharges (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.CompanyChargesdataSource.filter = filterValue.trim().toLowerCase()

    if (this.CompanyChargesdataSource.paginator) {
      this.CompanyChargesdataSource.paginator.firstPage()
    }
  }
  applyFilterLocation (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value

    this.OnLocation(filterValue.trim().toLowerCase())
    if (this.CompanyChargesdataSource.paginator) {
      this.CompanyChargesdataSource.paginator.firstPage()
    }
  }
  applyFilterSearch (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceSearch.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceSearch.paginator) {
      this.dataSourceSearch.paginator.firstPage()
    }
  }
  OnEditarLocalitation (datos: ResponseLocalitationNew) {
    this.ButtonLocalizzacionText = 'Save'
    this.editarLocalizacion = true
    this.editarlocalzacionId = datos.id

    this.FormularioLocalizzacion.controls.Location.setValue(
      String(datos.location)
    )
    this.FormularioLocalizzacion.controls.Length.setValue(
      String(datos.locationLength)
    )
    this.FormularioLocalizzacion.controls.Width.setValue(
      String(datos.locationWidth)
    )
    this.FormularioLocalizzacion.controls.Heigth.setValue(
      String(datos.locationHeight)
    )
    this.FormularioLocalizzacion.controls.Temperature.setValue(
      String(datos.locationTemperature)
    )
    this.FormularioLocalizzacion.controls.quantity.setValue(
      String(datos.lowQuantity)
    )
    this.FormularioLocalizzacion.controls.Description.setValue(
      String(datos.locationDescription)
    )
    this.FormularioLocalizzacion.controls.Type.setValue(
      Number(datos.locationType)
    )
    var tipos = datos.active
    if (tipos) {
      this.FormularioLocalizzacion.controls.checked.setValue('1')
    } else {
      this.FormularioLocalizzacion.controls.checked.setValue('0')
    }
  }
  OnLocationNewOrEdit () {
    if (this.FormularioLocalizzacion.invalid) {
      return
    }
    this.OnChangeLoader()
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['location'] = String(
      this.FormularioLocalizzacion.controls.Location.value
    )
    Request['locationLength'] = String(
      this.FormularioLocalizzacion.controls.Length.value || '1.00'
    )
    Request['locationWidth'] = String(
      this.FormularioLocalizzacion.controls.Width.value || '1.00'
    )
    Request['locationHeight'] = String(
      this.FormularioLocalizzacion.controls.Heigth.value || '1.00'
    )
    Request['locationTemperature'] = String(
      this.FormularioLocalizzacion.controls.Temperature.value || '1.00'
    )
    Request['lowQuantity'] = String(
      this.FormularioLocalizzacion.controls.quantity.value || '1.00'
    )
    Request['locationDescription'] = String(
      this.FormularioLocalizzacion.controls.Description.value || ' '
    )
    Request['locationType'] = String(
      this.FormularioLocalizzacion.controls.Type.value
    )
    if (this.editarLocalizacion) {
      Request['tipo'] = Number(this.editarlocalzacionId)
    } else {
      Request['tipo'] = 0
    }

    if (this.FormularioLocalizzacion.controls.checked.value == '1') {
      Request['active'] = true
    } else {
      Request['active'] = false
    }

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/LocationsInsertUpdate`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.respuestaLocation = response.responses

        if (
          this.respuestaLocation.includes('insert') ||
          this.respuestaLocation.includes('update')
        ) {
          Swal.fire({
            icon: 'info',
            title: 'Werehouse',
            text: 'success'
          })
          this.FormularioLocalizzacion.controls.Location.setValue(null)
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Werehouse',
            text: this.respuestaLocation
          })
        }
        this.ButtonLocalizzacionText = 'Saved'
        this.editarLocalizacion = false
        this.editarlocalzacionId = 0
        this.OnClearLocalitation()
      })
  }
  OnClearLocalitation () {
    //this.FormularioLocalizzacion.controls.Length.setValue(null);
    //this.FormularioLocalizzacion.controls.Width.setValue(null);
    //this.FormularioLocalizzacion.controls.Heigth.setValue(null);
    //this.FormularioLocalizzacion.controls.Temperature.setValue(null);
    //this.FormularioLocalizzacion.controls.quantity.setValue(null);
    //this.FormularioLocalizzacion.controls.Description.setValue(null);
    //this.FormularioLocalizzacion.controls.Type.setValue(Number(0));
    //this.FormularioLocalizzacion.controls.checked.setValue('0');
    this.ButtonLocalizzacionText = 'Saved'
    this.editarLocalizacion = false
    this.editarlocalzacionId = 0

    this.OnLocation('')
  }
  OnEditarUsers (datos: ResponseUsersAdmin) {
    this.editarID = datos.id
    this.EditarTxto = 'Save'

    this.formularioUsuarios.controls.permiso.setValue(datos.IMSApp)
    if (datos.Active) {
      this.formularioUsuarios.controls.activo.setValue('1')
    } else {
      this.formularioUsuarios.controls.activo.setValue('0')
    }
    this.formularioUsuarios.controls.name.setValue(datos.Name)
    this.formularioUsuarios.controls.lastname.setValue(datos.Last_Name)
    this.formularioUsuarios.controls.Address.setValue(datos.User_Address)
    this.formularioUsuarios.controls.City.setValue(datos.City)
    this.formularioUsuarios.controls.State.setValue(datos.User_State)
    this.formularioUsuarios.controls.Zip.setValue(datos.Zip)
    this.formularioUsuarios.controls.Phone.setValue(datos.Phone)
    this.formularioUsuarios.controls.Fax.setValue(datos.Fax)
    this.formularioUsuarios.controls.Email.setValue(datos.Email)
    this.formularioUsuarios.controls.Password.setValue(datos.UserPassword)
    this.formularioUsuarios.controls.customer.setValue(
      Number(datos.ClientAccNum) ||
        this.formularioUsuarios.controls.customer.disable()
    )
    this.viewUsers = false
  }
  OnNewOrEditUsers () {
    this.OnChangeLoader()
    var Request = {}
    if (this.editarID != 0) {
      Request['Tipo'] = this.editarID
    } else {
      Request['Tipo'] = 0
    }

    Request['CompanyID'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    if (this.formularioUsuarios.controls.permiso.value == '2') {
      Request['ClientAccNum'] = String(
        this.formularioUsuarios.controls.customer.value
      )
    } else {
      Request['ClientAccNum'] = ''
    }
    Request['Name'] = this.formularioUsuarios.controls.name.value
    Request['Last_Name'] = this.formularioUsuarios.controls.lastname.value
    Request['User_Address'] = this.formularioUsuarios.controls.Address.value
    Request['City'] = this.formularioUsuarios.controls.City.value
    Request['User_State'] = this.formularioUsuarios.controls.State.value
    Request['Zip'] = this.formularioUsuarios.controls.Zip.value
    Request['Phone'] = this.formularioUsuarios.controls.Phone.value
    Request['Fax'] = this.formularioUsuarios.controls.Fax.value
    Request['Email'] = this.formularioUsuarios.controls.Email.value
    Request['UserPassword'] = this.formularioUsuarios.controls.Password.value

    Request['Active'] = Boolean(this.formularioUsuarios.controls.activo.value)

    Request['IMSApp'] = this.formularioUsuarios.controls.permiso.value
    Request['SearchOrder'] = Number(this.permiso1value)
    Request['PlaceOrder'] = Number(this.permiso2value)
    Request['InventoryAvailable'] = Number(this.permiso3value)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/NewUsersOEdit`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OncancekUsers()
        this.OnViewSearch()
      })
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.PlaceOrderCustomer = response
      })
  }
  OnChangePerfil (data: any) {
    if (data == '2') {
      this.PerfilCustomer = true
      this.permiso1 = false
      this.permiso2 = false
      this.permiso3 = false
      this.formularioUsuarios.controls.customer.enable()
    } else {
      this.PerfilCustomer = false
      this.permiso1 = true
      this.permiso2 = true
      this.permiso3 = true
      this.formularioUsuarios.controls.customer.disable()
    }
  }
  OncancekUsers () {
    this.editarID = 0
    this.EditarTxto = 'Save'

    this.formularioUsuarios.controls.permiso.setValue('0')

    this.formularioUsuarios.controls.activo.setValue('0')

    this.formularioUsuarios.controls.name.setValue(null)
    this.formularioUsuarios.controls.lastname.setValue(null)
    this.formularioUsuarios.controls.Address.setValue(null)
    this.formularioUsuarios.controls.City.setValue(null)
    this.formularioUsuarios.controls.State.setValue(null)
    this.formularioUsuarios.controls.Zip.setValue(null)
    this.formularioUsuarios.controls.Phone.setValue(null)
    this.formularioUsuarios.controls.Fax.setValue(null)
    this.formularioUsuarios.controls.Email.setValue(null)
    this.formularioUsuarios.controls.Password.setValue(null)
    this.formularioUsuarios.controls.customer.setValue(null)
    this.formularioUsuarios.controls.customer.enable()
    this.PerfilCustomer = false
    this.permiso1 = true
    this.permiso2 = true
    this.permiso3 = true
    this.permiso1value = false
    this.permiso2value = false
    this.permiso3value = false
    this.viewUsers = true
  }
  openDialogLector (): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      this.dataSource.filter = result.Resultado.trim().toLowerCase()

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage()
      }
    })
  }
  openDialogLector2 (): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      this.dataSourceSearch.filter = result.Resultado.trim().toLowerCase()

      if (this.dataSourceSearch.paginator) {
        this.dataSourceSearch.paginator.firstPage()
      }
    })
  }

  OnChangeLoader () {
    this.spinner.show()

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide()
    }, 2000)
  }
  openDialogTypeLocation (): void {
    this.datosDialogTypeLocations = {
      key: 0,
      value: '',
      disponible: true
    }
    const dialogRef = this.dialog.open(AddTypeLocationsComponent, {
      width: '250px',
      data: this.datosDialogTypeLocations
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

      var Request = {}
      Request['companyId'] = Number(
        this.authenticationService.currentUserValue.companyIdWh
      )
      Request['name'] = result.value
      Request['active'] = Number(result.disponible)
      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Administracion/NewLocationsTypes`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization: 'Bearer ' + json.token
            })
          }
        )
        .subscribe((response: any) => {
          this.OnTypeLocationSelect()
          if (response.responses == 'success') {
          } else {
          }
        })
    })
  }
  OnTypeLocationSelect () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/SerchLocationsTypes`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: RRequesttypeLocations[]) => {
        this.arraytypeLocation = response
        this.arraytypeLocationselest = response
      })
  }

  onKey (value) {
    console.log(value)
    this.arraytypeLocationselest = this.search(value)
    console.log(this.arraytypeLocationselest)
  }

  search (value: string) {
    let filter = value.toLowerCase()
    return this.arraytypeLocation.filter(option =>
      option.value.toLowerCase().includes(filter)
    )
  }
  @ViewChild('exportExcel') table: ElementRef
  exportAsExcel () {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.ResponseLocalitationExcel
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }

  OnChangeInvoiceList () {
    //dataLogin
    this.dataWms=JSON.parse(localStorage.getItem("dataLogin"))
    this.onInvoiceHeaderRequest();
    /* var Rquest = {}
    Rquest['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['active'] = 1
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/ReceivingInvoicelistSelect`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.invoiceList = response
      }) */
  }

  onInvoiceHeaderRequest(){

    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/InvoiceHeaderSelect?CompanyId=${Number( this.authenticationService.currentUserValue.companyIdWh)}`,
       
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseInvoiceHeader[]) => {
       // this.invoiceList = response
       this.ResponseInvoiceHeader=response;
       this.onAccesorialChargesRequest();
       console.log(response)
      })



  }

  onAccesorialChargesRequest(){

    // this._httpClient
    //   .get<any>(
    //     `${environment.accounting}/Income/SelectInvoiceItemList?tblCompanyId=${Number( this.ResponseInvoiceHeader[0].tblAccountingId)}&searchType=INCOME&Active=true`,
       
    //     {
    //       headers: new HttpHeaders({
    //         'Access-Control-Allow-Origin': '*',
    //         'Access-Control-Allow-Headers': '*',
    //         'Access-Control-Allow-Methods': '*',
    //         Authorization:
    //           'Bearer ' + this.authenticationService.currentUserValue.token
    //       })
    //     }
    //   )
    //   .subscribe((response: ResponseInvoiceItemsList[]) => {
    //    // this.invoiceList = 
    //    this.ResponseInvoiceItemsList=response;
    //    console.log(response)
    //  })

      var Rquest = {}
      Rquest['companyId'] = Number(
        this.authenticationService.currentUserValue.companyIdWh
      )
      Rquest['active'] = 1
      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Administracion/ReceivingInvoicelistSelect`,
          Rquest,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {
          this.ResponseInvoiceItemsList=response;
        })

  }

  onselectchanger (datos: any) {
    console.log(datos)
    this.FomCompanyCharges.controls.Accessorial.setValue(datos.value.value)
    this.FomCompanyCharges.controls.Accessorial.disable()
  }

  OnEditCompanyChages (datos: ResponseCompanyChargesAccounting) {
    console.log(datos)
    this.editChargesCompany = datos.Id
    var hh = this.filterDatainvoiceList(datos.tblInvoiceListID)
    this.FomCompanyCharges.controls.invoiceList.setValue(hh[0])
    this.FomCompanyCharges.controls.Amount.setValue(datos.ChargeAmount)
    this.FomCompanyCharges.controls.Active.setValue(datos.Active)
    this.FomCompanyCharges.controls.Integrated.setValue(datos.QBIntegrated)

    this.FomCompanyCharges.controls.Accessorial.setValue(datos.Accessorial)
    this.FomCompanyCharges.controls.IntegratedStatus.setValue(
      datos.QBIntegratedStatus
    )

    this.FomCompanyCharges.controls.Accessorial.disable()
  }

  OnCancelCompany () {
    this.FomCompanyCharges.controls.Amount.setValue(null)
    this.FomCompanyCharges.controls.Active.setValue(true)
    this.FomCompanyCharges.controls.Integrated.setValue(false)

    this.FomCompanyCharges.controls.Accessorial.setValue(null)
    this.FomCompanyCharges.controls.IntegratedStatus.setValue(false)
  }
  filterDatainvoiceList (locationName: number) {
    return this.ResponseInvoiceItemsList.filter(object => {
      if (object['id'] == locationName) {
        return object
      }
    })
  }
  OnInsertOREditCompanyCharges () {
    this.datosSelectChange = this.FomCompanyCharges.controls.invoiceList.value
    var Request = {}
    Request['tipo'] = Number(this.editChargesCompany)
    Request['CompanyID'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['Accessorial'] = String(this.datosSelectChange.value)
    Request['ChargeAmount'] = String(
      this.FomCompanyCharges.controls.Amount.value
    )
    Request['Active'] = Number(this.FomCompanyCharges.controls.Active.value)
    Request['tblInvoiceListID'] = Number(this.datosSelectChange.key)
    Request['QBIntegrated'] = Number(
      this.FomCompanyCharges.controls.Integrated.value
    )
    Request['QBIntegratedStatus'] = Number(
      this.FomCompanyCharges.controls.IntegratedStatus.value
    )
    Request['QBListID'] = null
    Request['QBChartOfAccount'] = null
    Request['tblChartOfAccountID'] = Number(this.datosSelectChange.tblChartOfAccountId)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/NewCompanyCharges`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.editChargesCompany = 0
        this.OnChargesCompanyView()
        this.OnCancelCompany()
      })
  }

  OnChargesCompanyView () {
    var Rquest = {}
    Rquest['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['active'] = Number(this.selectedCOmpanyCharges)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CompanyChargesSeac`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseCompanyChargesAccounting[]) => {
        this.arrayTableCompanyCharges = response
        this.CompanyChargesdataSource = new MatTableDataSource(
          this.arrayTableCompanyCharges
        )
        this.CompanyChargesdataSource.sort = this.CompanyChargessort
        this.CompanyChargesdataSource.paginator = this.CompanyChargespaginator
      })
  }
  OnCustomerCharges () {
    var Rquest = {}
    Rquest['tblCompanyChargesID'] = Number(
      this.idCompanyCharges 
    )
    //Rquest['active'] = Number(this.selectedCustomerCharges)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CustomersCharges_Select`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseCustomerChargesAccounting[]) => {
        try {
          this.arrayDataCustomerCharges = response
          this.CustomerChargesSource = new MatTableDataSource(
            this.arrayDataCustomerCharges
          )
          this.CustomerChargesSource.sort = this.CustomerChargessort
          this.CustomerChargesSource.paginator = this.CustomerChargespaginator
        } catch (error) {}
      })
  }
  OnAddCustomer (datos: ResponseCompanyChargesAccounting) {
    console.log(datos,"OnAddCustomer")
    this.idCompanyCharges = datos.Id
    this.tab1 = false
    this.tabfalse = true
    this.indexTabs24 = new FormControl(1)
    this.OnCustomerCharges();
  }

  OnCustomerChargesNew () {
    var Rquest = {}
    Rquest['companyCharges'] = Number(this.idCompanyCharges)
    Rquest['tipo'] = Number(this.IdCustomerChargesEdit)
    Rquest['customerID'] = Number(
      this.FromCustomerCharges.controls.custome.value
    )

    Rquest['amount'] = String(this.FromCustomerCharges.controls.Amount.value)
    Rquest['active'] = Number(this.FromCustomerCharges.controls.Active.value)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/NewCustomerCharges`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        ///this.idCompanyCharges = 0
        this.IdCustomerChargesEdit = 0
        this.FromCustomerCharges.controls.custome.setValue(null)
        this.FromCustomerCharges.controls.custome.enable()
        this.FromCustomerCharges.controls.Amount.setValue(null)
        this.FromCustomerCharges.controls.Active.setValue(true)
        this.OnCustomerCharges()
      })
  }
  OnClearCustomerCharge () {
    this.tab1 = true
    this.tabfalse = false
    this.indexTabs24 = new FormControl(0)
    this.idCompanyCharges = 0
    this.IdCustomerChargesEdit = 0
    this.FromCustomerCharges.controls.custome.setValue(null)
    this.FromCustomerCharges.controls.custome.enable()
    this.FromCustomerCharges.controls.Amount.setValue(null)
    this.FromCustomerCharges.controls.Active.setValue(true)
  }

  OnEditCutstomerCharges (datos: ResponseCustomerChargesAccounting) {
    console.log(datos,"OnEditCutstomerCharges")
    this.FromCustomerCharges.controls.custome.setValue(datos.tblCustomerID)
    this.FromCustomerCharges.controls.custome.disable()
    this.FromCustomerCharges.controls.Amount.setValue(datos.Amount)
    //  this.FromCustomerCharges.controls.Amount.disable();
    this.FromCustomerCharges.controls.Active.setValue(datos.Active)
    this.idCompanyCharges = datos.tblCompanyChargesID
    this.IdCustomerChargesEdit = datos.id
  }

  OnSelectRoutingVariable (data: any) {
    console.log(data)
    this.selectedDescription = data.value
    this.OnSelectRouting()
  }
  OnEdit (datos: any) {
    this.EditRouting = Number(datos.key)
    this.FormRouting.controls.Description.setValue(String(datos.value))
    this.FormRouting.controls.Active.setValue(Boolean(this.selectedDescription))
    this.viewRouting = false
    console.log(datos)
  }
  OnSelectRouting () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = Number(json.companyIdWh)
    Request['active'] = Number(this.selectedDescription)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Shipping/RoutingDescriptionsSelect`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayDescripionRouting = response
      })
  }
  OnNewOrEditRouting () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['tipo'] = Number(this.EditRouting)
    Request['text'] = String(this.FormRouting.controls.Description.value)
    Request['company'] = Number(json.companyIdWh)
    Request['active'] = Number(this.FormRouting.controls.Active.value)
    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/RoutingNewOrUpdate`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.EditRouting = 0
        this.FormRouting.controls.Description.setValue('')
        this.FormRouting.controls.Active.setValue(Boolean(0))
        this.viewRouting = true
        this.OnSelectRouting()
      })
  }
  OpenDialogEmailConfingSend (data: any): void {
    const dialogRef = this.dialog.open(AddSendEmailComponent, {
      width: '40vw',
      height: '60vh',
      data: data
    })

    dialogRef.afterClosed().subscribe(result => {})
  }
  onSaveFormWarehouseNameLocation () {
    this.ResponseWarehouseNameLocation = {
      ID: Number(this.FormWarehouseName.controls.ID.value),
      CompanyID: Number(
        this.authenticationService.currentUserValue.companyIdWh
      ),
      Warehouse_Name: String(
        this.FormWarehouseName.controls.Warehouse_Name.value
      ),
      Contact_Name: String(this.FormWarehouseName.controls.Contact_Name.value),
      Address: String(this.FormWarehouseName.controls.Address.value),
      Address1: String(this.FormWarehouseName.controls.Address1.value),
      City: String(this.FormWarehouseName.controls.City.value),
      State: String(this.FormWarehouseName.controls.State.value),
      Zip: String(this.FormWarehouseName.controls.Zip.value),
      Phone: String(this.FormWarehouseName.controls.Phone.value),
      Fax: String(this.FormWarehouseName.controls.Fax.value),
      Email: String(this.FormWarehouseName.controls.Email.value),
      Logo: '',
      Admin_License: Number(1),
      Partner_License: Number(1),
      Client_License: Number(1),
      Active: Boolean(this.FormWarehouseName.controls.Active.value),
      Company_Website: '',
      PaymentBTN: 0,
      Date_Created: new Date(new Date().setHours(0, 0, 0, 0)),
      orderBy: Number(this.FormWarehouseName.controls.orderBy.value)
    }
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/warehouseNameLocationInsetUpdatePost`,
        this.ResponseWarehouseNameLocation,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.onCleaarFromWarehouseName()
        this.onTableWarehouseNameLocation()
      })
  }
  onCleaarFromWarehouseName () {
    this.FormWarehouseName.reset({
      ID: [0],
      CompanyID: [0],
      Warehouse_Name: [''],
      Contact_Name: [''],
      Address: [''],
      Address1: [''],
      City: [''],
      State: [''],
      Zip: [''],
      Phone: [''],
      Fax: [''],
      Email: [''],
      Logo: [''],
      Admin_License: [1],
      Partner_License: [1],
      Client_License: [1],
      Active: [true],
      Company_Website: [''],
      PaymentBTN: [0],
      Date_Created: [new Date(new Date())],
      orderBy: [1]
    })
  }

  onTableWarehouseNameLocation () {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/warehouseNameLocationSelectGet?CompanyID=${this.authenticationService.currentUserValue.companyIdWh}&active=1`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseWarehouseNameLocation[]) => {
        this.ResponseWarehouseNameLocationArray = []
        this.ResponseWarehouseNameLocationArray = response
      })
  }
  openDialogWarehouseName (da: ResponseWarehouseNameLocation): void {
    const dialogRef = this.dialog.open(WarehouseNameLocationComponent, {
      width: '80vw',
      height: '80vh',
      data: { PlaceOrderCustomer: this.PlaceOrderCustomer, id: da.ID ,view:true}
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')
    })
  }
  openDialogWarehouseNamewithoutProducts (da: ResponseWarehouseNameLocation): void {
    const dialogRef = this.dialog.open(WarehouseNameLocationComponent, {
      width: '80vw',
      height: '80vh',
      data: { PlaceOrderCustomer: this.PlaceOrderCustomer, id: da.ID ,view:false}
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')
    })
  }

  onEditFromWarehouseName (da: ResponseWarehouseNameLocation) {
    this.FormWarehouseName.reset({
      ID: [da.ID],
      CompanyID: [this.authenticationService.currentUserValue.companyIdWh],
      Warehouse_Name: [da.Warehouse_Name],
      Contact_Name: [da.Contact_Name],
      Address: [da.Address],
      Address1: [da.Address1],
      City: [da.City],
      State: [da.State],
      Zip: [da.Zip],
      Phone: [da.Phone],
      Fax: [da.Fax],
      Email: [da.Email],
      Logo: [da.Logo],
      Admin_License: [da.Admin_License],
      Partner_License: [da.Partner_License],
      Client_License: [da.Client_License],
      Active: [da.Active],
      Company_Website: [da.Company_Website],
      PaymentBTN: [0],
      Date_Created: [da.Date_Created],
      orderBy: [da.orderBy]
    })
  }
}
